import { useDeviceType } from '../../hooks';
/**
 * Компонента которая рендерит children только на выбранных типах устройства
 */
export var Responsive = function Responsive(_ref) {
  var phone = _ref.phone,
    tablet = _ref.tablet,
    desktop = _ref.desktop,
    children = _ref.children;
  var deviceType = useDeviceType();
  var shouldRender = phone && deviceType === 'phone' || tablet && deviceType === 'tablet' || desktop && deviceType === 'desktop';
  if (shouldRender) {
    return children;
  }
  return null;
};